import {normalizeActionHandler} from '../utils/config/normalizeActionHandler';
import {createInterceptors} from '../utils/config/createInterceptors';
import {ACTION_HANDLERS, TARGETED_ACTION_TYPES, CONFIG} from '../symbols';
import {addActionHandler} from './customEventActionHandler';
import {onAction} from './onAction';

export function addActionHandlerForUnknownType(host, type, hostVariables) {
	if (!(type in hostVariables[CONFIG].interceptors)) {
		const actionHandler = normalizeActionHandler(() => {}, host.tagName);

		const interceptors = createInterceptors({
			[type]: actionHandler
		});

		hostVariables[CONFIG].interceptors = {...hostVariables[CONFIG].interceptors, ...interceptors}; // eslint-disable-line no-param-reassign
	}

	const removeActionHandler = addActionHandler(host, null, host, type, false, false, onAction);
	hostVariables[ACTION_HANDLERS].push(removeActionHandler);
	hostVariables[TARGETED_ACTION_TYPES] = [...hostVariables[TARGETED_ACTION_TYPES], type]; // eslint-disable-line no-param-reassign
}
